import { uuid } from '../utils'
import Vue from 'vue'
import dayjs from 'dayjs'

import {
  postOrder,
  getOrder,
  putOrder,
  orderApprove,
  orderUnApprove,
  orderDateModify,
  orderVoid,
  orderClose,
  orderNext,
  orderHistory as historyApi,
  getCustomers,
  getProductsInfo,
  getBalance,
  orderSendXero,
  orderRecallFromXero
} from '../api'

import {
  routeINV,
  routeCN,
  routePO,
  routeBCN,
  routeBL,
  routeTR,
  routeAJ
} from '../router'

export const productTpl = {
  id: 0,
  code: '',
  name: '',
  stocks: [],
  prices: [],
  unit: '',
  cost: ''
}

export const lineTpl = {
  id: 0,
  quantity: '',
  inWarehouseQty: '',
  inSystemQty: '',
  price: '',
  desc: '',
  product: {}
}

function prepare (state) {
  const { csr, lines, ...params } = state
  if (csr.id) {
    params.customerId = csr.id
  }

  if (state.type === 3 && params.dueDate) {
    delete params.dueDate
  }

  let i = 1
  params.lines = lines.map(l => {
    const { product, ...line } = l
    line.seq = i
    line.productId = product.id
    i++
    return line
  })

  return params
}

function prepareApprove (state) {
  const params = {}
  if (state.type === 1 || state.type === 2) {
    params.warehouseId = state.warehouseId
    params.shipType = state.shipType
    // params.deliveryDate = state.deliveryDate
    params.driverId = state.driverId
  }
  return params
}

function findLine (lines, id) {
  const index = lines.findIndex(d => d.id === id)
  const line = lines[index]
  return [index, line]
}

function calcDueByPayType (paymentType) {
  const orgId = Number.parseInt(localStorage.getItem('orgId') || 0)
  const isSYD = orgId >= 9
  // const isCOD = paymentType.toLowerCase().indexOf('cod') !== -1
  const isWeek = paymentType.toLowerCase().indexOf('week') !== -1
  const isFortnight = paymentType.toLowerCase().indexOf('night') !== -1
  const isMonth = paymentType.toLowerCase().indexOf('month') !== -1
  const is30Days = paymentType.toLowerCase().indexOf('30') !== -1
  let result = ''
  if (isWeek) {
    // 次周1
    result = dayjs().add(1, 'week').day(1).format('YYYY-MM-DD')
  } else if (isMonth && !isSYD) {
    // 当月最后1天  除了悉尼
    result = dayjs().endOf('month').format('YYYY-MM-DD')
  } else if (isMonth && isSYD) {
    // 次月第1天 悉尼
    result = dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD')
  } else if (isFortnight && dayjs().$D < 15) {
    // 15日之前，则14号
    result = dayjs().date(14).format('YYYY-MM-DD')
  } else if (isFortnight && dayjs().$D >= 15) {
    // 15日（含）之后，则月末
    result = dayjs().endOf('month').format('YYYY-MM-DD')
  } else if (is30Days) {
    // 30日，则顺延30天
    result = dayjs().add(30, 'day').format('YYYY-MM-DD')
  } else {
    // 其余情况均为当天，包括COD
    result = dayjs().format('YYYY-MM-DD')
  }
  return result
}

function formatPriceType (type) {
  return type.replace(/ /g, '').toLowerCase()
}

const emptyTpl = {
  id: 0,
  no: '',
  type: 0,
  uuid: '',
  tagId: '',
  csr: {},
  date: '',
  dueDate: '',
  deliveryDate: '',
  address: '',
  csrServiceId: '',
  csrBDId: '',
  driverId: 0,
  deliveryStatus: 0,
  actualPayType: 0,
  deliveryComment: '',
  csrCreditLimit: '',
  csrXeroBalance: '',
  reference: '',
  phone: '',
  comments: '',
  csrSelfNote: '',
  warehouseId: '',
  relatedNo: '',
  taxType: 0,
  inWarehouseId: '',
  shipType: '',
  paymentType: '',
  areaType: '',
  priceType: '',
  status: '',
  closure: '',
  xeroSent: '',
  print: '',
  drafterType: '',
  lines: []
}
export default {
  namespaced: true,
  state: {
    ...emptyTpl
  },
  getters: {
    csrId: state => state.csr.id || '',
    csrName: state => state.csr.name || '',
    addressAndPhone: state => `${state.address} / Phone: ${state.phone}` || '',
    line: state => id => state.lines.find(d => d.id === id),
    lineProduct: (state, getters) => id => getters.line(id).product,
    lineQty: (state, getters) => id => getters.line(id).quantity,
    lineInQty: (state, getters) => id => getters.line(id).inWarehouseQty,
    lineSysQty: (state, getters) => id => getters.line(id).inSystemQty,
    linePrice: (state, getters) => id => getters.line(id).price,
    lineTaxType: (state, getters, rootState, rootGetters) => {
      return rootGetters.getTaxTypeName(state.taxType)
    },
    lineDesc: (state, getters) => id => getters.line(id).desc,
    orderTypeName: (state, getters, rootState, rootGetters) =>
      rootGetters.orderTypeName(state.type),

    btnShow: state => btnName => {
      let stateType12 = state.type === 1 || state.type === 2
      let stateType3 = state.type === 3
      let stateType1245 =
        state.type === 1 ||
        state.type === 2 ||
        state.type === 4 ||
        state.type === 5

      switch (btnName) {
        case 'edit':
          return true
        case 'approve':
          return state.status === 'Draft'
        case 'unapprove':
          return state.status === 'Approved' && state.xeroSent !== 'Sent'
        case 'sendXero':
          return (
            state.status === 'Approved' &&
            state.xeroSent !== 'Sent' &&
            stateType1245
          )
        case 'xeroRecall':
          return state.xeroSent === 'Sent' && stateType1245
        case 'print':
          return (stateType12 && state.status === 'Approved') || (state.type === 2 && state.status === 'Draft')
        case 'close':
          return (
            state.closure !== 'Closed' &&
            state.status === 'Approved' &&
            stateType3
          )
        case 'void':
          return state.status === 'Draft'
        default:
          return false
      }
    },
    canModifyContent: state => state.status === 'Draft',
    totalAmount: state =>
      state.lines
        .reduce((total, item) => (total += item.quantity), 0)
        .toFixed(0),
    totalQtyDifference: (state) => {
      return state.lines
        .reduce((total, item) => (total += ((item.inWarehouseQty || 0) - (item.inSystemQty || 0))), 0)
        .toFixed(0)
    },
    totalPrice: state =>
      state.lines
        .reduce((total, item) => (total += item.quantity * item.price), 0)
        .toFixed(2),
    totalTax: (state, getters) => {
      let taxFunc
      if (state.taxType === 2 || state.taxType === 3) {
        taxFunc = price => price / 11
      } else {
        taxFunc = () => 0
      }
      return taxFunc(getters.totalPrice).toFixed(2)
    },
    subTotal: (state, getters) =>
      (getters.totalPrice - getters.totalTax).toFixed(2),
    includesGstForPrint: (state, getters) =>
      (getters.totalPrice / 11).toFixed(2)
  },
  mutations: {
    init: state => {
      // deep copy tpl here
      const tpl = JSON.parse(JSON.stringify(emptyTpl))
      for (const prop in state) {
        Vue.set(state, prop, tpl[prop])
      }
      state.uuid = uuid()
    },
    setId: (state, id) => (state.id = id),
    setNumber: (state, no) => (state.no = no),
    setType: (state, type) => (state.type = type),
    setTag: (state, tag) => (state.tagId = tag),
    // setCsr: (state, csr) => (state.csr = csr),
    setCsr: (state, csr) => {
      state.csr = csr
    },
    newLine: state => {
      const line = { ...lineTpl, product: { ...productTpl } }
      line.id = 'new_' + uuid()
      state.lines.push(line)
    },
    copyLine: (state, id) => {
      const line = state.lines.find(d => d.id === id)
      const newLine = { ...line, id: 'new_' + uuid() }
      state.lines.push(newLine)
    },
    deleteLine: (state, id) => {
      // console.log(state.lines)
      // console.log(`begin to delete ${id}`)
      const index = state.lines.findIndex(l => l.id === id)
      // console.log(`find the index ${index}`)

      state.lines.splice(index, 1)
      // console.log(state.lines)
    },
    clearLine: state => (state.lines = []),
    addLine: (state, line) => {
      state.lines.push(line)
    },
    setProduct: (state, { id, product }) => {
      const [index, line] = findLine(state.lines, id)
      line.product = product
      // 在填入货品时，加入了判断，如果存在客户，那么填入时unit price取该客户价格类型的值，姚爷看看这样写对不？
      if (state.csr.priceType) {
        const cType = formatPriceType(state.csr.priceType)
        const p = product.prices.find(
          item => formatPriceType(item.type) === cType
        ) || { price: 0 }
        line.price = p.price
      }
      Vue.set(state.lines, index, line)
    },
    updateProductInfo: (state, products) => {
      const lines = state.lines.map(l => {
        if (l.product && l.product.id) {
          const product = products.find(p => p.id === l.product.id)
          if (product) {
            return { ...l, product }
          }
        }
        return { ...l }
      })
      state.lines = lines
    },
    setQty: (state, { id, qty }) => {
      const [index, line] = findLine(state.lines, id)
      line.quantity = qty
      Vue.set(state.lines, index, line)
    },
    setInQty: (state, { id, qty }) => {
      const [index, line] = findLine(state.lines, id)
      line.inWarehouseQty = qty || 0
      Vue.set(state.lines, index, line)
    },
    setSysQty: (state, { id, qty }) => {
      const [index, line] = findLine(state.lines, id)
      line.inSystemQty = qty || 0
      Vue.set(state.lines, index, line)
    },

    setPrice: (state, { id, price }) => {
      const [index, line] = findLine(state.lines, id)
      line.price = price
      Vue.set(state.lines, index, line)
    },
    // 增加一个mutations：切换csr客户后，遍历lines将全部line的价格都改掉，
    // ，姚爷看看这样写对不？
    setAllLinesPrices: state => {
      state.lines.forEach((line, index) => {
        if (line.price) {
          const cType = formatPriceType(state.csr.priceType)
          const p = line.product.prices.find(
            item => formatPriceType(item.type) === cType
          ) || { price: 0 }
          line.price = p.price
          Vue.set(state.lines, index, line)
        }
      })
    },
    setLineDescription: (state, { id, desc }) => {
      const [index, line] = findLine(state.lines, id)
      line.desc = desc
      Vue.set(state.lines, index, line)
    },
    setDate: (state, date) => (state.date = date),
    setDueDate: (state, date) => (state.dueDate = date),
    setDueDateByPayType: (state, paymentType) => (state.dueDate = calcDueByPayType(paymentType)),
    setDeliveryDate: (state, date) => (state.deliveryDate = date),
    setAddress: (state, address) => (state.address = address),
    setCsrServicer: (state, id) => (state.csrServiceId = id),
    setCsrCreditLimit: (state, value) => (state.csrCreditLimit = value),
    setCsrXeroBalance: (state, value) => (state.csrXeroBalance = value),
    setBD: (state, id) => (state.csrBDId = id),
    setDriver: (state, id) => (state.driverId = id),
    setDlvStatus: (state, id) => (state.deliveryStatus = id),
    setActualPayType: (state, id) => (state.actualPayType = id),
    setDlvCommet: (state, value) => (state.deliveryComment = value),
    setReference: (state, reference) => (state.reference = reference),
    setPhone: (state, phone) => (state.phone = phone),
    setComments: (state, comments) => (state.comments = comments),
    setCsrSelfNote: (state, note) => (state.csrSelfNote = note),
    setWarehouse: (state, id) => (state.warehouseId = id),
    setInWarehouse: (state, id) => (state.inWarehouseId = id),
    setShipType: (state, value) => (state.shipType = value),
    setPaymentType: (state, value) => (state.paymentType = value),
    setAreaType: (state, value) => (state.areaType = value),
    setPriceType: (state, value) => (state.priceType = value),
    setTaxType: (state, id) => (state.taxType = id),
    setRelatedNo: (state, no) => (state.relatedNo = no),
    setStatus: (state, status) => (state.status = status),
    setXeroSent: (state, status) => (state.xeroSent = status),
    setPrint: (state, status) => (state.print = status),
    setClosure: (state, status) => (state.closure = status),
    setDrafterType: (state, drafterType) => (state.drafterType = drafterType)
  },
  actions: {
    setCsrWithAutoCmplt (context, csr) {
      context.commit('setCsr', csr)
      context.commit('setAddress', csr.address)
      context.commit('setPhone', csr.phone)
      let staffs = context.rootState.staff
      context.commit('setBD', null)
      context.commit('setCsrServicer', null)

      if (csr.csrService) {
        const csId = staffs.find(d => d.label === csr.csrService).value
        context.commit('setCsrServicer', csId)
      }
      if (csr.csrBD) {
        const bdId = staffs.find(d => d.label === csr.csrBD).value
        context.commit('setBD', bdId)
      }
    },
    copyLines: (context, ids) =>
      ids.forEach(id => context.commit('copyLine', id)),
    deleteLines: (context, ids) =>
      ids.forEach(id => context.commit('deleteLine', id)),

    initEdit: async (context, { routeName, id }) => {
      // const routeName = context.rootGetters.getRouteNameFromOrderType(context.state.type)
      // let loading = Loading.service({
      //     lock: true,
      //     text: 'Loading',
      //     spinner: 'el-icon-loading',
      // })
      await context.dispatch('initConfig', { routeName, opType: 'edit' })
      await context.dispatch('loadOrder', id)
      // loading.close()
    },
    initAdd: async (context, routeName) => {
      context.commit('init')
      const type = context.rootGetters.getOrderTypeFromRouteName(routeName)
      context.commit('setType', type)
      context.commit('setDate', dayjs().format('YYYY-MM-D'))
      context.commit('setDeliveryDate', dayjs().format('YYYY-MM-D'))
      await context.dispatch('initConfig', { routeName, opType: 'edit' })
    },
    initAddFromCart: async (context, clear = false) => {
      await context.dispatch('initAdd', routeINV)
      const carts = context.rootState.cart.carts

      let csr = context.rootState.cart.csr
      if (csr.id) {
        csr = getCustomers({ id: csr.id })
        csr = (await csr).data
        if (csr && csr.length && csr.length > 0) {
          context.commit('setCsr', csr[0])
          context.commit('setAddress', csr[0].address || '')
          context.commit('setPhone', csr[0].phone || '')
          context.commit('setBD', null)
          context.commit('setCsrServicer', null)
          if (csr[0].csrBD) {
            const bdId = context.rootGetters.getStaffId(csr[0].csrBD)
            context.commit('setBD', bdId === 0 ? '' : bdId)
          } else {
            context.commit('setBD', '')
          }
          if (csr[0].csrService) {
            const salesId = context.rootGetters.getStaffId(csr[0].csrService)
            context.commit('setCsrServicer', salesId === 0 ? '' : salesId)
          } else {
            context.commit('setCsrServicer', '')
          }
        }
      }

      let products = carts.map(item => item.id).join(',')
      const productParam = { id: products }
      if (csr.id) {
        productParam.cId = csr.id
      }
      productParam.per_page = carts.length <= 20 ? 20 : carts.length
      products = getProductsInfo(productParam)
      products = (await products).data
      carts.forEach(item => {
        const product = products.find(p => p.id === item.id)
        if (product) {
          const line = { ...lineTpl, product, quantity: item.qty }
          line.id = 'new_' + uuid()
          context.commit('addLine', line)
        }
      })
      if (clear) {
        context.dispatch('cart/clearCart', null, { root: true })
      }
    },
    initConfig: (context, { routeName, opType }) => {
      switch (routeName) {
        case routeINV:
          context.commit('setTaxType', 3)
          context.commit('config/setInv', opType, { root: true })
          break
        case routeCN:
          context.commit('config/setCN', opType, { root: true })
          // context.commit('setSearchApi', { prepare: _invPrepare, api: getOrders })
          break
        case routePO:
          context.commit('setTag', 1)
          context.commit('config/setPO', opType, { root: true })
          // context.commit('setSearchApi', { prepare: _pcPrepare, api: getOrders })
          break
        case routeBL:
          context.commit('config/setBL', opType, { root: true })
          // context.commit('setSearchApi', { prepare: _pcPrepare, api: getOrders })
          break
        case routeBCN:
          context.commit('config/setBCN', opType, { root: true })
          // context.commit('setSearchApi', { prepare: _pcPrepare, api: getOrders })
          break
        case routeTR:
          context.commit('config/setTR', opType, { root: true })
          // context.commit('setSearchApi', { prepare: _pcPrepare, api: getOrders })
          break
        case routeAJ:
          context.commit('config/setAJ', opType, { root: true })
          // context.commit('setSearchApi', { prepare: _pcPrepare, api: getOrders })
          break
      }
    },
    create: async context => {
      const params = prepare(context.state)
      // console.log(params)
      let data
      if (context.state.id > 0) {
        data = await putOrder(context.state.id, params)
      } else {
        data = await postOrder(params)
      }
      return data
    },
    cloneTo: async (context, routeName) => {
      const tmpState = { ...context.state }

      await context.dispatch('initAdd', routeName)

      const type = context.rootGetters.getOrderTypeFromRouteName(routeName)
      if (tmpState.type === 3 && type !== 3) {
        context.commit('setRelatedNo', tmpState.no)
      }

      context.commit('setType', type)
      context.commit('setTag', tmpState.tagId || '')
      context.commit('setCsr', tmpState.csr || {})
      context.commit('setDate', tmpState.date || '')
      context.commit('setDueDate', tmpState.dueDate || '')
      context.commit('setDeliveryDate', tmpState.deliveryDate || '')
      context.commit('setAddress', tmpState.address || '')
      context.commit('setCsrServicer', tmpState.csrServiceId || '')
      context.commit('setCsrCreditLimit', tmpState.csrCreditLimit || '')
      context.commit('setCsrXeroBalance', tmpState.csrXeroBalance || '')
      context.commit('setBD', tmpState.csrBDId || '')
      context.commit('setReference', tmpState.reference || '')
      context.commit('setPhone', tmpState.phone || '')
      context.commit('setComments', tmpState.comments || '')
      context.commit('setCsrSelfNote', tmpState.csrSelfNote || '')
      context.commit('setDriver', tmpState.driverId || '')

      context.commit('setWarehouse', tmpState.warehouseId || '')
      context.commit('setInWarehouse', tmpState.inWarehouseId || '')
      context.commit('setShipType', tmpState.shipType || '')
      context.commit('setPaymentType', tmpState.paymentType || '')
      context.commit('setAreaType', tmpState.areaType || '')
      // context.commit('setRelatedNo', tmpState.relatedNo || '')
      context.commit('setTaxType', tmpState.taxType || '')

      tmpState.lines.forEach(l => {
        const line = {
          id: `new_${uuid()}`,
          quantity: l.quantity || 0,
          inWarehouseQty: l.inWarehouseQty || 0,
          inSystemQty: l.inSystemQty || 0,
          price: l.price || 0,
          line_amount: l.amount || 0,
          desc: l.description || '',
          product: l.product,
          unit: l.unit
        }
        context.commit('addLine', line)
      })
    },
    cloneBillToInv: async (context, routeName) => {
      const tmpState = { ...context.state }

      await context.dispatch('initAdd', routeName)

      const type = context.rootGetters.getOrderTypeFromRouteName(routeName)

      context.commit('setType', type)
      context.commit('setTag', tmpState.tagId || '')
      context.commit('setDate', tmpState.date || '')
      context.commit('setReference', tmpState.no || '')

      tmpState.lines.forEach(l => {
        const line = {
          id: `new_${uuid()}`,
          quantity: l.quantity || 0,
          price: undefined,
          desc: l.description || '',
          product: l.product,
          unit: l.unit
        }
        context.commit('addLine', line)
      })
    },
    handleApprove: async context => {
      const params = prepareApprove(context.state)
      return orderApprove(context.state.id, params)
    },

    handleUnApprove: async context => {
      return orderUnApprove(context.state.id)
    },

    handleClose: async context => {
      return orderClose(context.state.id)
    },

    handleVoid: async context => {
      return orderVoid(context.state.id)
    },

    loadOrder: async (context, id) => {
      const order = (await getOrder(id)).data
      context.commit('setId', order.id || 0)
      context.commit('setType', order.type || '')
      context.commit('setNumber', order.no || '')
      context.commit('setTag', order.tagId || '')
      context.commit('setCsr', order.customer || {})
      context.commit('setDate', order.date || '')
      context.commit('setDueDate', order.dueDate || '')
      context.commit('setDeliveryDate', order.deliveryDate || '')
      context.commit('setAddress', order.address || '')
      context.commit('setCsrServicer', order.csrServiceId || '')
      context.commit('setBD', order.csrBDId || '')
      context.commit('setDriver', order.driverId || '')
      context.commit('setDlvStatus', order.deliveryStatus)
      context.commit('setActualPayType', order.actualPayType || '')
      context.commit('setDlvCommet', order.deliveryComment || '')
      context.commit('setReference', order.reference || '')
      context.commit('setPhone', order.phone || '')
      context.commit('setComments', order.comments || '')
      context.commit('setCsrSelfNote', order.csrSelfNote || '')

      context.commit('setWarehouse', order.warehouseId || '')
      context.commit('setInWarehouse', order.inWarehouseId || '')
      context.commit('setShipType', order.shipType || '')
      context.commit('setPaymentType', order.customer.paymentType || '')
      context.commit('setAreaType', order.customer.areaType || '')
      context.commit('setPriceType', order.customer.priceType || '')
      context.commit('setRelatedNo', order.relatedNo || '')
      context.commit('setTaxType', order.taxType || 0)
      context.commit('setStatus', order.status || '')
      context.commit('setXeroSent', order.xeroSent || '')
      context.commit('setPrint', order.print || '')
      context.commit('setClosure', order.closure || '')
      context.commit('setDrafterType', order.drafterType || '')
      context.commit('clearLine')
      const lines = order.details || []
      lines
        .sort((a, b) => a.seq - b.seq)
        .forEach(l => {
          const line = {
            id: l.id,
            quantity: l.quantity || 0,
            inWarehouseQty: l.inWarehouseQty || 0,
            inSystemQty: l.inSystemQty || 0,
            price: l.price || 0,
            line_amount: l.amount || 0,
            desc: l.description || '',
            product: l.product,
            unit: l.unit,
            stock_3rdP: l.stock_3rdP
          }
          context.commit('addLine', line)
        })
    },

    initShow: async (context, id) => {
      // let loading = Loading.service({
      //     lock: true,
      //     text: 'Loading',
      //     spinner: 'el-icon-loading',
      // })
      await context.dispatch('loadOrder', id)
      const routeName = context.rootGetters.getRouteNameFromOrderType(
        context.state.type
      )
      await context.dispatch('initConfig', {
        routeName: routeName,
        opType: context.state.status
      })
      // loading.close()
      // 后置请求xero balance，避免过于堵塞
      if (context.state.type === 1 || context.state.type === 2) {
        const csrCredit = (await getBalance(context.state.csr.id)).data
        context.commit('setCsrCreditLimit', csrCredit.creditLimit)
        context.commit('setCsrXeroBalance', csrCredit.xeroBalance)
      }
      // 如果是shop端下单，那么加载本draft时，自动修改时间
      if (context.state.type === 1 && context.state.drafterType === 3 && context.state.status === 'Draft') {
        let newDueDate = calcDueByPayType(context.state.csr.paymentType)
        const result = await orderDateModify(id,
          { date: context.state.date,
            dueDate: newDueDate,
            deliveryDate: context.state.deliveryDate || dayjs().format('YYYY-MM-DD')
          })
        if (result.id > 0) {
          context.commit('setDueDate', newDueDate)
        }
      }
    },

    nextId: async (context, type) => {
      return orderNext(context.state.id, { type })
    },

    orderHistory: async (context, id) => {
      return historyApi(id)
    },
    setCsrWithInfo: async (
      { dispatch, commit, state, getters, rootGetters },
      { data, bus }
    ) => {
      const csr = data
      commit('setCsr', csr)
      commit('setAddress', csr.address || '')
      commit('setPhone', csr.phone || '')
      commit('setBD', null)
      commit('setCsrServicer', null)
      if (csr.csrBD) {
        const bdId = rootGetters.getStaffId(csr.csrBD)
        commit('setBD', bdId === 0 ? '' : bdId)
      } else {
        commit('setBD', '')
      }
      if (csr.csrService) {
        const salesId = rootGetters.getStaffId(csr.csrService)
        commit('setCsrServicer', salesId === 0 ? '' : salesId)
      } else {
        commit('setCsrServicer', '')
      }
      // console.log(csr.priceType)
      // if (csr.priceType === 'OCOP') {
      let products = state.lines.filter(l => l.product && l.product.id)
      if (products.length > 0) {
        products = products.map(item => item.product.id).join(',')
        products = getProductsInfo({ id: products, cId: csr.id })
        products = (await products).data
        commit('updateProductInfo', products)
        state.lines.forEach(l => {
          bus.$emit(`product-selected-${l.id}`, l.product)
        })
      }
      // }
      commit('setAllLinesPrices')
    },
    sendXero: async context => {
      return orderSendXero(context.state.id)
    },
    recallFromXero: async context => {
      return orderRecallFromXero(context.state.id)
    }
  }
}
